import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';
import { journalPatientConfirmSentence } from '@/lib/journalPatientConfirm';
import { TYPE } from '@/lib/typography';
import { cn } from '@/utils/cn';

export function JournalPatientConfirmDialog({
  open,
  patientName,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  patientName: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  const name = patientName.trim() || '—';
  const lead = t('journal.confirm_patient_lead');
  const question = t('journal.confirm_patient_question');
  const sentence = journalPatientConfirmSentence(name, lead, question);

  return (
    <Modal
      open={open}
      title={t('journal.confirm_patient_title')}
      onClose={onCancel}
      tone="warning"
      showIcon
      role="alertdialog"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button type="button" variant="primary" onClick={onConfirm}>
            {t('journal.finalize')}
          </Button>
        </>
      }
    >
      <div role="group" aria-label={sentence}>
        <p aria-hidden className={cn(TYPE.body, 'text-ds-text')}>
          {lead}
        </p>
        <div aria-hidden className="mt-s3 rounded-card bg-ds-amber-tint px-s4 py-s4 text-center">
          <p className={cn(TYPE.display, 'font-bold text-ds-text')} data-patient-name>
            "{name}"
          </p>
        </div>
        <p aria-hidden className={cn(TYPE.heading, 'mt-s4 text-ds-text')}>
          {question}
        </p>
      </div>
    </Modal>
  );
}
